import { FETCH_ACTIVE_PGAPPS_START, FETCH_ACTIVE_PGAPPS_SUCCESS, FETCH_ACTIVE_PGAPPS_FAILURE, UPDATE_NOTIFICATION_FAILURE, UPDATE_NOTIFICATION_SUCCESS, UPDATE_NOTIFICATION_START, GET_UNREAD_NOTIFICATION_START, GET_UNREAD_NOTIFICATION_SUCCESS, GET_UNREAD_NOTIFICATION_FAILURE } from "./appTypes";

export const initialState = {
    activeApps: [],
    errors: [],
    loading: false,
    unreadNotifications: [],
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ACTIVE_PGAPPS_START:
            return {
                ...state,
                loading: true,
            }
        case FETCH_ACTIVE_PGAPPS_SUCCESS:
            return {
                ...state,
                activeApps: action.activeApps,
                loading: false,
            }
        case FETCH_ACTIVE_PGAPPS_FAILURE:
            return {
                ...state,
                loading: false,
                errors: action.errors,
            }
        case UPDATE_NOTIFICATION_START:
            return {
                ...state
            }
        case UPDATE_NOTIFICATION_SUCCESS:
            return {
                ...state,
            }
        case UPDATE_NOTIFICATION_FAILURE:
            return {
                ...state
            }

        case GET_UNREAD_NOTIFICATION_START:
            return {
                ...state
            }
        case GET_UNREAD_NOTIFICATION_SUCCESS:
            return {
                ...state,
                unreadNotifications: action.notification
            }
        case GET_UNREAD_NOTIFICATION_FAILURE:
            return {
                ...state,
                unreadNotifications: []
            }

        default:
            return state;
    }
}



export default appReducer;